import { useReducer, useMemo, type ReactNode } from 'react';
import { reducer, initialState } from './reducer';
import { AppContext } from './hooks';

export function AppProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
